<div [ngClass]="theme">
  <div class="item-header">
    <div class="sale-badge" *ngIf="product.campaignId && product?.isDiscount && product?.discountPercentage > 3">
      <span *ngIf="saleBadge">{{ product?.discountPercentage.toFixed(0) }}% Off</span>
      <span *ngIf="!saleBadge">
        {{ 'On sale' | translate }}
      </span>
    </div>
    <div class="wishlist">
      <app-wishlist-icon
        [productId]="product?.id"
        [hit]="product"
        [prdImg]="product?.imageUrl"
        (error)="product.imageUrl = originalUrl"
        (outputCall)="callBack()"
      ></app-wishlist-icon>
    </div>
  </div>

  <div class="item-image">
    <a
      class="img-link"
      routerLink="/{{ product?.stylesSeoUrl ?? 'item' }}"
      [queryParams]="{ pdp: product?.id, position: product?.position }"
    >
      <img
        class="img"
        [defaultImage]="'assets/images/placeholder.png'"
        [lazyLoad]="imageUrl"
        [errorImage]="originalUrl"
        [alt]="product?.name"
        *ngIf="isImageLazyLoaded"
      />
      <img
        class="img"
        [src]="imageUrl"
        [alt]="product?.name"
        fetchpriority="high"
        tvb-img-fallback
        *ngIf="!isImageLazyLoaded"
      />
    </a>
  </div>

  <div class="item-details">
    <!-- ** Disable we love ** -->
    <!-- <div class="tags">
      <tvb-badge
        id="listing-badge"
        label="We Love"
        backgroundColor="#EDE9E1"
        color="#000"
        borderRadius="50px"
        *ngIf="isWeLove()"
      ></tvb-badge>
    </div> -->

    <div class="brand">
      <a class="tvb-link" routerLink="/designer/{{ product?.brandsSeoUrl ?? 'item' }}" *ngIf="product?.brandsSeoUrl">
        {{ product?.brandName }}
      </a>
    </div>

    <div class="name text-overflow-ellipsis" [title]="product?.name">
      <a class="tvb-link" routerLink="/{{ product?.brandsSeoUrl ?? 'item' }}" [queryParams]="{ pdp: product?.id }">
        {{ product?.name }}
      </a>
    </div>

    <div class="size" [ngStyle]="{ visibility: shouldShowSizeInfo() ? 'visible' : 'hidden' }">
      <a class="tvb-link" routerLink="/{{ product?.brandsSeoUrl ?? 'item' }}" [queryParams]="{ pdp: product?.id }">
        <span class="size-label">{{ 'Size' | translate }}&nbsp;</span>
        <span class="size-value">{{ product?.shoesSize || product?.clothingSize || product?.bagsSize }}&nbsp;EU</span>
      </a>
    </div>

    <br *ngIf="theme !== 'pdp'" />

    <div class="price">
      <span class="price-value" *ngIf="!product.campaignId">
        <div class="regular-price" *ngIf="product?.isDiscount">
          {{ product['discountedPrice' + appConfig?.currencyCode.toUpperCase()] | currency: appConfig?.currencyCode }}
        </div>
        <div class="regular-price" *ngIf="!product?.isDiscount">
          {{ product['regularPrice' + appConfig?.currencyCode.toUpperCase()] | currency: appConfig?.currencyCode }}
        </div>
      </span>
      <span class="price-value" *ngIf="product.campaignId">
        <div class="regular-price" [ngClass]="{ 'text-line-through': product?.isDiscount }">
          {{ product['regularPrice' + appConfig?.currencyCode.toUpperCase()] | currency: appConfig?.currencyCode }}
        </div>

        <div class="discount-price" *ngIf="product?.isDiscount">
          {{ product['discountedPrice' + appConfig?.currencyCode.toUpperCase()] | currency: appConfig?.currencyCode }}
        </div>
      </span>
    </div>
  </div>
</div>
